import { Component } from '@angular/core';
import { BaseComponent } from '../../../base.component';
import { MatDialogRef } from '@angular/material/dialog';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { openAiSettingsActions } from '@store/third-party/open-ai-settings/open-ai-settings.actions';
import { Store } from '@ngrx/store';
import { currentOpenAiSettings } from '@store/third-party/open-ai-settings/open-ai-settings.selector';
import { takeUntil } from 'rxjs';
import { GptModelList, OpenAIModel } from '@models/open-ai-gpt.model';

@Component({
    selector: 'lex-open-ai-setting-dialog-new',
    templateUrl: './open-ai-setting-dialog-new.component.html',
    styleUrls: ['./open-ai-setting-dialog-new.component.scss'],
    standalone: false
})
export class OpenAiSettingDialogNewComponent extends BaseComponent {

	public models = GptModelList;
	public openAiSettingForm: FormGroup;
	public isLinked: boolean;
	private currentKey: string = '';

	constructor(
		private store: Store,
		private formBuilder: FormBuilder,
		private dialogRef: MatDialogRef<OpenAiSettingDialogNewComponent>) {
		super();
		this.openAiSettingForm = this.formBuilder.group({
			apiKey: ['', Validators.required],
			apiModel: [OpenAIModel.GPT4Omni, Validators.required]
		});

		this.store.select(currentOpenAiSettings())
			.pipe(takeUntil(this.destroy$))
			.subscribe(
				(settings) => {
					if (settings.isAccountKey) {
						this.isLinked = settings.isLinked;
						if (settings.apiKey) {
							this.openAiSettingForm.get('apiKey').setValue(settings.apiKey);
							this.currentKey = settings.apiKey;
						}
						if (settings.model)
							this.openAiSettingForm.get('apiModel').setValue(settings.model);
					}
				});
	}

	public link(): void {
		if (this.openAiSettingForm.invalid)
			return;
		this.store.dispatch(openAiSettingsActions.createLink({
			settings: {
				isLinked: this.isLinked,
				apiKey: this.openAiSettingForm.get('apiKey').value,
				model: this.openAiSettingForm.get('apiModel').value,
				isAccountKey: false
			}
		}));
		this.dialogRef.close(true);
	}

	public submit(): void {
		if (this.openAiSettingForm.invalid)
			return;
		this.store.dispatch(openAiSettingsActions.update({
			settings: {
				isLinked: this.isLinked,
				apiKey: this.openAiSettingForm.dirty && this.openAiSettingForm.get('apiKey').value !== this.currentKey ? this.openAiSettingForm.get('apiKey').value : '',
				model: this.openAiSettingForm.get('apiModel').value,
				isAccountKey: false
			}
		}));
		this.dialogRef.close(true);
	}

	public emptyProps(): void {
		this.store.dispatch(openAiSettingsActions.deleteLink({
			settings: {
				isLinked: this.isLinked,
				isAccountKey: false
			}
		}));
		this.dialogRef.close(true);
	}
}
